(() => {
  if (window.SWVariantSelectorLoaded) return;
  window.SWVariantSelectorLoaded = true;

  const instances = new WeakMap();

  const colourMap = {
  black: '#000000',
  white: '#ffffff',
  blue: '#2563eb',
  'royal blue': '#4169e1',
  royal: '#4169e1',
  navy: '#000080',
  red: '#dc2626',
  orange: '#f97316',
  yellow: '#facc15',
  green: '#16a34a',
  grey: '#808080',
  gray: '#808080',
  'zoom grey': '#808080',
  'metal grey': '#8E8E8E',
  charcoal: '#36454f',
  purple: '#9333ea',
  pink: '#ec4899',
  brown: '#795548',
  beige: '#d6c6a5',
  lime: '#84cc16',
  rose: '#E887B7',
  'hi-vis yellow': '#e6ff00',
  'hi vis yellow': '#e6ff00',
  'hi-vis orange': '#ff7a00',
  'hi vis orange': '#ff7a00'
};

  class SWVariantSelector {
    constructor(element) {
      this.element = element;

      this.dataElement = element.querySelector(
        '.sw-variant-selector__data'
      );

      if (!this.dataElement) return;

      try {
        this.data = JSON.parse(this.dataElement.textContent);
      } catch (error) {
        console.error('Variant selector JSON error', error);
        return;
      }

      this.variants = this.data.variants || [];

      this.card =
        element.closest('.sw-has-variant-selector') ||
        element.closest('.product-card-wrapper');

      this.primaryImage =
        this.card?.querySelector('.sw-card-primary-image') || null;

      this.originalImage = this.primaryImage
        ? {
            src: this.primaryImage.getAttribute('src'),
            srcset: this.primaryImage.getAttribute('srcset')
          }
        : null;

      this.optionGroups = [
        ...element.querySelectorAll(
          '.sw-variant-selector__option'
        )
      ];

      this.buttons = [
        ...element.querySelectorAll(
          '.sw-variant-selector__value'
        )
      ];

      this.selected = [];

      const defaultVariant =
        this.variants.find(
          variant =>
            String(variant.id) ===
            String(this.data.defaultVariantId)
        ) ||
        this.variants.find(variant => variant.available) ||
        this.variants[0];

      if (defaultVariant) {
        this.selected = [...defaultVariant.options];
      }

      this.setupColours();
      this.bindEvents();
      this.refresh();
    }

    setupColours() {
    this.element
        .querySelectorAll('.sw-variant-selector__swatch')
        .forEach(swatch => {
        const rawName = (swatch.dataset.colour || '').trim();
        const name = rawName.toLowerCase();

        if (!name) {
            swatch.style.display = 'none';
            return;
        }

        // Handle combinations like Black/Grey, Black/Orange, Navy/Blue
        const parts = name
            .split(/[\/+&-]/)
            .map(part => part.trim())
            .filter(Boolean);

        const resolveColour = colourName => {
            if (colourMap[colourName]) {
            return colourMap[colourName];
            }

            if (CSS.supports('color', colourName)) {
            return colourName;
            }

            return null;
        };

        if (parts.length >= 2) {
            const colour1 = resolveColour(parts[0]);
            const colour2 = resolveColour(parts[1]);

            if (colour1 && colour2) {
            swatch.style.background =
                `linear-gradient(135deg, ${colour1} 0 50%, ${colour2} 50% 100%)`;
            return;
            }
        }

        const colour = resolveColour(name);

        if (colour) {
            swatch.style.background = colour;
        } else {
            // Unknown colour name: don't show an empty circle
            swatch.style.display = 'none';
        }
        });
    }

    bindEvents() {
      this.buttons.forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();

          if (button.disabled) return;

          const position =
            Number(button.dataset.optionPosition) - 1;

          const value = button.dataset.value;

          this.selectOption(position, value);
        });

        if (
          button.classList.contains(
            'sw-variant-selector__value--colour'
          )
        ) {
          button.addEventListener(
            'mouseenter',
            () => {
              this.previewOption(
                Number(
                  button.dataset.optionPosition
                ) - 1,
                button.dataset.value
              );
            }
          );

          button.addEventListener(
            'mouseleave',
            () => {
              this.updateImage();
            }
          );
        }
      });

      const toggle = this.element.querySelector(
        '.sw-variant-selector__toggle'
      );

      if (toggle) {
        toggle.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();

          const open =
            !this.element.classList.contains('is-open');

          this.element.classList.toggle(
            'is-open',
            open
          );

          toggle.setAttribute(
            'aria-expanded',
            String(open)
          );
        });
      }
    }

    selectOption(position, value) {
      this.selected[position] = value;

      /*
       * Find the first available variant matching all
       * options up to and including the one just selected.
       *
       * This means:
       * Colour -> choose first available size
       * Size   -> retain colour and choose exact size
       * Option 3 -> resolve exact combination
       */
      const matchingVariant =
        this.variants.find(variant => {
          if (!variant.available) return false;

          for (let i = 0; i <= position; i++) {
            if (
              this.selected[i] &&
              variant.options[i] !== this.selected[i]
            ) {
              return false;
            }
          }

          return true;
        });

      if (matchingVariant) {
        for (
          let i = position + 1;
          i < matchingVariant.options.length;
          i++
        ) {
          this.selected[i] =
            matchingVariant.options[i];
        }
      }

      this.refresh();
    }

    refresh() {
      this.updateButtons();
      this.updateImage();
      this.updateProductLinks();
    }

    updateButtons() {
      this.buttons.forEach(button => {
        const position =
          Number(button.dataset.optionPosition) - 1;

        const value = button.dataset.value;

        const selected =
          this.selected[position] === value;

        /*
         * Availability is based on earlier options.
         *
         * Colour:
         *   available if ANY variant in that colour exists.
         *
         * Size:
         *   available if that size exists in the selected
         *   colour.
         *
         * Third option:
         *   depends on Colour + Size.
         */
        const available =
          this.variants.some(variant => {
            if (!variant.available) return false;

            if (
              variant.options[position] !== value
            ) {
              return false;
            }

            for (let i = 0; i < position; i++) {
              if (
                this.selected[i] &&
                variant.options[i] !==
                  this.selected[i]
              ) {
                return false;
              }
            }

            return true;
          });

        button.classList.toggle(
          'is-selected',
          selected
        );

        button.classList.toggle(
          'is-unavailable',
          !available
        );

        button.disabled = !available;

        button.setAttribute(
          'aria-pressed',
          String(selected)
        );
      });
    }

    getSelectedVariant() {
      return (
        this.variants.find(variant => {
          return variant.options.every(
            (option, index) =>
              option === this.selected[index]
          );
        }) || null
      );
    }

    updateImage() {
      const variant = this.getSelectedVariant();

      if (variant?.image) {
        this.setImage(variant.image);
      } else {
        this.restoreImage();
      }
    }

    previewOption(position, value) {
      const variant =
        this.variants.find(variant => {
          if (!variant.image) return false;

          if (
            variant.options[position] !== value
          ) {
            return false;
          }

          for (let i = 0; i < position; i++) {
            if (
              this.selected[i] &&
              variant.options[i] !==
                this.selected[i]
            ) {
              return false;
            }
          }

          return variant.available;
        }) ||
        this.variants.find(variant => {
          return (
            variant.image &&
            variant.options[position] === value
          );
        });

      if (variant?.image) {
        this.setImage(variant.image);
      }
    }

    setImage(url) {
      if (!this.primaryImage || !url) return;

      this.primaryImage.src = url;

      /*
       * Dawn's srcset would otherwise override the new src.
       */
      this.primaryImage.removeAttribute('srcset');
    }

    restoreImage() {
      if (!this.primaryImage || !this.originalImage) {
        return;
      }

      if (this.originalImage.src) {
        this.primaryImage.src =
          this.originalImage.src;
      }

      if (this.originalImage.srcset) {
        this.primaryImage.setAttribute(
          'srcset',
          this.originalImage.srcset
        );
      }
    }

    updateProductLinks() {
      const variant = this.getSelectedVariant();

      if (!variant) return;

      const baseUrl =
        this.element.dataset.productUrl;

      if (!baseUrl) return;

      const url =
        `${baseUrl}?variant=${variant.id}`;

      this.card
        ?.querySelectorAll(
          'a[href*="/products/"]'
        )
        .forEach(link => {
          link.href = url;
        });
    }
  }

  function initialise(root = document) {
    root
      .querySelectorAll(
        '.sw-variant-selector'
      )
      .forEach(element => {
        if (instances.has(element)) return;

        const instance =
          new SWVariantSelector(element);

        instances.set(element, instance);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialise()
    );
  } else {
    initialise();
  }

  /*
   * Shopify collection filtering replaces the product
   * grid dynamically. Observe new cards and initialise
   * them automatically.
   */
  const observer = new MutationObserver(
    mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;

          if (
            node.matches('.sw-variant-selector')
          ) {
            initialise(node.parentElement);
          } else if (
            node.querySelector(
              '.sw-variant-selector'
            )
          ) {
            initialise(node);
          }
        });
      });
    }
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();